import { Component } from 'preact'
import axios from 'axios'
import TopicListItemView, { TopicInfo } from '../topic-list-view/TopicListItemView.sync'
import Phrase from '../../libs/translationsUtils/phrase'

interface Props {
  eventId: number
  attachmentCdn: string
}

interface State {
  topics: TopicInfo[]
  error: boolean
}

class FeaturedTopicsListAsSearchResults extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      topics: [],
      error: false
    }
  }

  async componentDidMount () {
    await this.loadTopics()
  }

  private async loadTopics () {
    this.setState({ error: false })
    try {
      const res = await axios.get(`/events/${this.props.eventId}/featuredTopics`)
      this.setState({ topics: res.data })
    } catch (err) {
      this.setState({ error: true })
    }
  }

  render ({ attachmentCdn }: Props, { error, topics }: State) {
    if (error) {
      return (
        <div className='event-featured-topics-error-container' id='featured-topics'>
          Something went wrong, we have troubles displaying topics.
          Please <a href='#featured-topics' onClick={async () => await this.loadTopics()}>try again</a>.
        </div>
      )
    }

    if (topics.length === 0) return null

    return (
      <div className='event-featured-topics-container'>
        <div className='event-attendees__header_label'><Phrase p='events.featured.topics' /></div>
        {
        topics.map((topic: TopicInfo, index) => <TopicListItemView
          key={index}
          hideCategoryMetadata={false} topic={topic} attachmentCdn={attachmentCdn}
          clickCallback={() => {
          }}
                                                />)
      }
      </div>
    )
  }
}

export default FeaturedTopicsListAsSearchResults
